import showActionNotification from '../../section/Common/utils/showActionNotification';

export const error403Config = [
  {
    match: () => true, // fallback
    handler: (error) => {
      showActionNotification({
        type: 'error',
        message:
          error.response?.data?.error ||
          'You do not have permission to access this resource'
      });
      throw error;
    }
  }
];

export const error400Config = [
  {
    match: (url: string) =>
      ['search/all', 'edit-custom-object', 'create-custom-object']
        .some(p => url.includes(p)),
    handler: (error) => error.response.data
  },
  {
    match: (url: string) => url.includes('manually'),
    handler: (error) => error.response
  }
];